module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/actuacion-adjunto/actuacion-adjunto.component.css
// module id = ./src/app/components/actuacion-adjunto/actuacion-adjunto.component.css
// module chunks = main